import { IEvaluationContext } from "../IEvaluationContext";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { MatchKind } from "../../../../../../Common/ModelPath/PathMatcher";
import { wrapDecimalOperand } from "../../../../Helpers/AutocalcCommonFunctions";
import { KCExpressionRuntime, PlainModelValue } from "../KCExpressionRuntime";
import { arrayHasLength } from "../../../../../../Common/TypingUtils";
import { ModelEvent } from "../../EventManagement/ModelEvents/ModelEvent";

export class KCSumCalculation {
    public static execute(
        context: IEvaluationContext,
        targetPath: AbsoluteModelPath,
        dependencyPath: AbsoluteModelPath,
        countPath: AbsoluteModelPath,
        defaultValue: string
    ): PlainModelValue {
        if (arrayHasLength(context.relatedEvents, 0)) {
            const expressionRuntime = new KCExpressionRuntime(context);
            return expressionRuntime.argument(dependencyPath.toLegacyPath()) ?? defaultValue;
        }

        const countValue = wrapDecimalOperand(context.get(countPath));
        if (countValue.eq(0)) {
            return defaultValue;
        }
        const currentValue = wrapDecimalOperand(context.get(context.resolvePath(targetPath)));
        const nextValue = Iterator.from(context.relatedEvents)
            .filter(evt =>
                dependencyPath
                    .matchFor(evt.path)
                    .every(x => x.kind === MatchKind.MatchedPath || x.kind === MatchKind.MatchedMultiplicity)
            )
            .reduce((sum, curr: ModelEvent) => {
                const oldValue = wrapDecimalOperand(curr.oldValue as string | undefined);
                const value = wrapDecimalOperand(curr.value as string | undefined);
                return sum.add(value.minus(oldValue));
            }, currentValue);
        return nextValue.toFixed();
    }
}
